const fromListStoreGroupsQueryToStoreGroup = (data) => {
  if (!data) {
    return {};
  }
  const sortedStores = [...data.multiStoreGroups, ...data.singleStoreGroups].sort(
    (a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())
  );
  const storeGroups = sortedStores.reduce((acc, value) => {
    const name = value.name?.toUpperCase();
    const firstNameStoreLetter = name?.[0];
    if (firstNameStoreLetter) {
      const existingStore = acc[firstNameStoreLetter] ?? [];
      return {
        ...acc,
        [firstNameStoreLetter]: [...existingStore, value]
      };
    }
    return acc;
  }, {});
  return storeGroups;
};
export {
  fromListStoreGroupsQueryToStoreGroup
};
//# sourceMappingURL=adapters.js.map
